import {Injectable} from '@angular/core';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {AusschreibungService} from './ausschreibung.service';

@Injectable({providedIn: 'root'})
export class PageTitleService extends TitleStrategy {
  private routeTitle = '';
  private title$ = new BehaviorSubject<string>('');

  constructor(ausschreibungService: AusschreibungService) {
    super();
    ausschreibungService.get().subscribe(ausschreibung => {
      if (this.routeTitle === 'Ausschreibung' && ausschreibung?.objekt) {
        this.title$.next('Ausschreibung ' + ausschreibung.objekt);
      }
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.routeTitle = this.buildTitle(snapshot) ?? '';
    this.title$.next(this.routeTitle);
  }

  get(): BehaviorSubject<string> {
    return this.title$;
  }
}
